export default __webpack_public_path__ + "static/media/temp stay E6 unpaid internship.6ef42a57.jpg";